import { getSymbolsForMultipleAccounts } from '@/api/exchangesApi';
import { MultipleAccountsRequestsPayload, SymbolsFilterItem } from '@/state/legs/legsTypes';
import { STALE_TIME_ONE_DAY } from '@/lib/constants';

export const symbolsListQueryKey = (
    params: MultipleAccountsRequestsPayload,
    isCompleted: boolean,
) => ['symbolsList', params, isCompleted] as const;

export const symbolsListQuery = (
    params: MultipleAccountsRequestsPayload,
    isCompleted: boolean,
) => ({
    queryKey: symbolsListQueryKey(params, isCompleted),
    queryFn: async (): Promise<SymbolsFilterItem[]> => {
        const { data } = await getSymbolsForMultipleAccounts(params);
        return data;
    },
    staleTime: STALE_TIME_ONE_DAY,
});
